<template>
<v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
        <v-card-text class="">
            <h2 class="indigo--text text--darken-4"><u>Qualités / Défauts</u></h2>
            <br>
            <v-row>
                <v-col cols="6" v-for="(type, index) in items" :key="'col-'+index">
                    <v-card color="blue-grey lighten-5"  class="fill-height">
                        <v-card-title class="justify-center blue-grey lighten-4 indigo--text text--darken-4">{{ type.label }} <i class="pl-3" :class="type.icon"></i></v-card-title>
                        <v-divider></v-divider>
                        <ul class="fa-ul ml-0 pl-0 mt-2 mb-2">
                            <li v-for="(item, i) in type.list" :key="type.label+'-'+i">
                                <span class="black--text">
                                    <strong v-html="item"></strong>
                                </span>
                            </li>
                        </ul>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-col>
    <v-col cols="1"></v-col>
</v-row>
</template>

<script>
export default {
    name: 'Qualities',
    data: () => ({
        items: [
        {
            label: 'Qualités',
            icon: 'fa fa-user-plus',
            list: ['Honnête', 'Autonome', 'Loyal', 'Persévérant']
        },
        {
            label: 'Défauts',
            icon: 'fa fa-user-minus',
            list: ['Franc', 'Indépendant']
        }
        ]
    }),
}
</script>
